module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl3-75.39fa6ae3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl3-75.png
// module id = 3569
// module chunks = 11